module.exports = __webpack_public_path__ + "static/media/IAQAnalytics5.873b45f5.png";